const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Components/DashboardHeader/DashboardHeaderComponent.tsx';
import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { GapSm } from 'App/components/Gap/Gap';

type DashboardHeaderProps = {
    patientName: string;
};

const DashboardHeaderComponent = (props: DashboardHeaderProps) => {
    const { patientName } = props;

    return (
        <Grid size={{ xs: 12 }}>
            <GapSm />
            <Typography variant="subtitle1" component="h2">
                {patientName}
            </Typography>
            <GapSm />
        </Grid>
    );
};

export default DashboardHeaderComponent;
